function initFilter(trigger, response) {
    if($(trigger).length) {
        $(trigger).submit(function(){
            var filter = $(trigger);
            $.ajax({
                url:filter.attr('action'),
                data:filter.serialize(), // form data
                type:filter.attr('method'), // POST
                beforeSend:function(xhr){
                    filter.find('button').text('Searching...'); // changing the button label
                },
                success:function(data){
                    filter.find('button').text('Search'); // changing the button label back
                    $(response).html(data); // insert data
                }
            });
            return false;
        });
    }
}

export default {
    initFilter : initFilter
}


// WEBPACK FOOTER //
// ./src/js/filter.js